import { render, staticRenderFns } from "./specialDesc.vue?vue&type=template&id=a83774d4&"
import script from "./specialDesc.vue?vue&type=script&lang=js&"
export * from "./specialDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports